import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { findSsoProvider, type SsoProviderId } from '@/constants/ssoProviders'
import { useSSO } from '@/hooks/useSSO'
import { cn } from '@/lib/utils'

interface Props {
  providerId: SsoProviderId
  inviteToken?: string
  className?: string
}

export const SsoProviderButton = ({
  providerId,
  inviteToken,
  className,
}: Props) => {
  const { startSSO } = useSSO()
  const { t } = useTranslation()
  const provider = findSsoProvider(providerId)
  if (!provider) return null
  const { Logo, labelKey } = provider

  return (
    <Button
      variant="secondary"
      type="button"
      className={cn(
        'flex h-12 w-full items-center justify-center gap-3 border-neutralColor30 px-6 py-3',
        className,
      )}
      onClick={() => startSSO(providerId, inviteToken)}
    >
      <Logo />
      {t(labelKey)}
    </Button>
  )
}

export default SsoProviderButton
